import React from 'react'

/**
 * "Log in or create an account" step of the reservation flow.
 *
 * Two cards side by side on desktop, stacked on mobile. Actions are handed
 * to the parent: the login form and the registration consent open in modals.
 */
const ReservationAuthChoicePanel = ({
    brandName = "KAV2GO",
    onLogin = () => {},
    onRegister = () => {},
    onChangeRentalParams = () => {},
}) => {
    return (
        <div className="kav-panel kav-auth-choice">
            <div className="kav-auth-choice__header">
                <h2 className="kav-auth-choice__title">Log in of maak een account aan</h2>
                <p className="kav-auth-choice__subtitle">Dit is nodig om je reservering af te ronden.</p>
            </div>

            <div className="kav-auth-choice__cards">
                <div className="kav-auth-choice__card">
                    <h3 className="kav-auth-choice__cardTitle">Al eerder gehuurd?</h3>
                    <p className="kav-auth-choice__cardText">Log in met je e-mailadres en wachtwoord.</p>
                    <button
                        type="button"
                        className="kav-step-actions__btn kav-step-actions__btn--outline kav-auth-choice__btn"
                        onClick={onLogin}
                    >
                        Inloggen
                    </button>
                </div>

                <div className="kav-auth-choice__card">
                    <h3 className="kav-auth-choice__cardTitle">Nieuw bij {brandName}?</h3>
                    <p className="kav-auth-choice__cardText">Maak een account aan en doorloop de rijbewijscheck.</p>
                    <button
                        type="button"
                        className="kav-step-actions__btn kav-step-actions__btn--primary kav-auth-choice__btn"
                        onClick={onRegister}
                    >
                        Account aanmaken
                    </button>
                </div>
            </div>

            <div className="kav-auth-choice__footer">
                <p className="kav-auth-choice__note">
                    Voor registratie heb je een geldig rijbewijs en een smartphone nodig.
                </p>
                <button
                    type="button"
                    className="kav-step-actions__btn kav-step-actions__btn--ghost kav-auth-choice__changeBtn"
                    onClick={onChangeRentalParams}
                >
                    <i className="bi bi-chevron-left" aria-hidden="true"></i>
                    Klik hier om de huurgegevens te wijzigen
                </button>
            </div>
        </div>
    )
}

export default ReservationAuthChoicePanel
